import { useRef, useState } from 'react'

import { useNotification } from 'commons/customHooks/useNotifications'
import i18n, { TranslateComponent } from 'commons/libs/i18n'
import {
  EnvironmentTag,
  HavLogo,
  Icon,
  Modal,
  Notifications,
  Tooltip,
  Typography,
} from 'components'
import { URL_CONST } from 'constants/urls'
import { useNavigate } from 'react-router-dom'
import { handleLogout } from 'store/AuthContext/authSlice'
import { useDispatch } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import { SUPPORT_EMAIL, SUPPORT_LINK } from '../Header/constants'
import * as S from './styles'

export const MenuTopbar = () => {
  const dispatch = useDispatch()

  const [openSupportModal, setOpenSupportModal] = useState(false)
  const [openNotifications, setOpenNotifications] = useState(false)

  const notifButtonRef = useRef<HTMLDivElement>(null)

  const navigate = useNavigate()
  const { processUnreadNotifications, unreadNotificationsData } = useNotification()

  const toggleNotifications = () => {
    if (openNotifications) {
      processUnreadNotifications()
    }
    setOpenNotifications(!openNotifications)
  }

  const logout = () => {
    navigate(URL_CONST.LOGIN)
    dispatch(handleLogout())
  }

  return (
    <S.Topbar>
      <HavLogo color={theme.colors.neutral.white} />

      <S.ButtonsWrapper>
        <EnvironmentTag />

        <Tooltip arrow placement="bottom" title={i18n.t('common.support')}>
          <S.IconButtonStyled onClick={() => setOpenSupportModal(true)}>
            <Icon color={theme.colors.neutral.white} icon="headset" size="18" />
          </S.IconButtonStyled>
        </Tooltip>

        <S.NotificationsButtonWrapper ref={notifButtonRef}>
          <Tooltip arrow placement="bottom" title={i18n.t('common.notifications')}>
            <S.IconButtonStyled onClick={toggleNotifications}>
              <Icon color={theme.colors.neutral.white} icon="bell" size="18" />
            </S.IconButtonStyled>
          </Tooltip>
          {!!unreadNotificationsData.length && (
            <S.NotificationNumberStyled>
              {unreadNotificationsData.length < 9 ? unreadNotificationsData.length : '9+'}
            </S.NotificationNumberStyled>
          )}
        </S.NotificationsButtonWrapper>

        {openNotifications && (
          <Notifications notifButtonRef={notifButtonRef} setOpen={setOpenNotifications} />
        )}

        <Tooltip arrow placement="bottom" title={i18n.t('common.exit')}>
          <S.IconButtonStyled onClick={logout}>
            <Icon color={theme.colors.neutral.white} icon="logout" size="18" />
          </S.IconButtonStyled>
        </Tooltip>
      </S.ButtonsWrapper>

      <Modal
        description={
          <Typography design="hav-default-03-text">
            <TranslateComponent
              components={{
                br: <br key="br" />,
                click_here: (
                  <S.SupportLink
                    href={SUPPORT_LINK}
                    key="click_here"
                    rel="noreferrer noopener"
                    target="_blank"
                  />
                ),
                email: (
                  <S.SupportLink
                    href={`mailto:${SUPPORT_EMAIL}`}
                    key="email"
                    rel="noreferrer noopener"
                    target="_blank"
                  />
                ),
                strong: <strong key="strong" />,
              }}
              i18nKey="components.header.supportModal.description"
              values={{ supportEmail: SUPPORT_EMAIL }}
            />
          </Typography>
        }
        open={openSupportModal}
        setOpen={setOpenSupportModal}
        showAction={false}
        title={i18n.t('components.header.supportModal.title')}
        titleSize={22}
      />
    </S.Topbar>
  )
}
